/**
 * Tasks page: scheduled tasks and execution history. Keys must match ../en/tasks.ts.
 */
const tasks = {
  page: {
    title: '任务',
    scheduledTab: '定时任务',
    historyTab: '执行历史',
  },
  /** BCP 47 locale for dates and times on this page (today it is always en-US). */
  dateLocale: 'zh-CN',
  scheduled: {
    title: '定时任务',
    description: 'Cron 任务管理 · 查看调度、执行历史和运行结果',
    loading: '正在加载任务…',
    loadFailed: '加载任务失败',
    errorTitle: '加载任务出错',
    emptyTitle: '暂无定时任务',
    emptyBody: '还没有创建任何任务。',
    filterEmptyTitle: '暂无任务',
    filterEmptyBody: '没有找到定时任务。',
    noMatchTitle: '没有匹配项',
    noMatchBody: '没有符合筛选条件的任务。',
    filterPlaceholder: '搜索任务',
    matches: '{{n}} 个匹配',
    hint: '通过右手边的对话框，你可以用自然语言创建和管理定时任务。告诉我「做什么、什么时候、做几次」即可。试试这样说：',
    hintIcon: '提示',
    example1: '"每周一早上 9 点给我发一份和我客户相关的新闻并说明对我 pipeline 的影响"',
    example2: '"每周二早上 10 点给我发一封邮件告知我 Top10 客户的 revenue 和 pipeline 进度"',
    example3: '"每天早上通过 Slack 提醒我需要 follow up 的 pipeline"',
    example4: '"帮我取消每天 Sales Daily Brief 的发送"',
  },
  columns: {
    name: '任务名称',
    payload: '任务内容',
    schedule: '调度',
    nextRun: '下次运行',
    lastRun: '上次运行',
    status: '状态',
    taskId: '任务 ID',
  },
  status: {
    scheduled: '正常',
    completed: '已完成',
    invokeFailed: '调用失败',
  },
  preferences: {
    title: '偏好设置',
    confirm: '确定',
    cancel: '取消',
    pageSize: '每页条数',
    pageSizeOption: '{{n}} 条',
    visibleColumns: '显示的列',
    taskProperties: '任务属性',
    wrapLines: '自动换行',
    wrapLinesDescription: '单元格内长文本自动换行',
    stripedRows: '斑马纹',
    stripedRowsDescription: '隔行显示底色',
  },
  history: {
    title: '执行历史',
    loadFailed: '加载执行历史失败',
    last7: '最近 7 天',
    last30: '最近 30 天',
    last90: '最近 90 天',
    statusAll: '状态：全部',
    statusSuccess: '成功',
    statusFailed: '失败',
    statusRunning: '运行中',
    contentTypeAll: '内容类型',
    emptyTitle: '暂无执行记录',
    emptyBody: '所选条件下没有执行记录。',
    // Count labels mirror today's `n > 1` rule (zh has one plural form, so i18next plurals cannot express it).
    itemsOne: '{{n}} 条',
    itemsMany: '{{n}} 条',
    errorsDetected: '（{{n}} 条出错）',
    taskId: '任务 ID：{{id}}',
    time: '时间：{{time}}',
    contentType: '内容类型：{{type}}',
    timeUsed: '耗时：{{duration}}',
    itemSuccess: '成功',
    itemError: '出错',
    itemRunning: '运行中',
  },
};

export default tasks;
